import Header from "./../header/Header.vue";
import Footer from "./../footer/Footer.vue";

export default {
  name: "LogotypeForm",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      logotypeForm: {
        valid: false,
        company: "",
        companyName: {
          field: "",
          rules: [v => !!v || "Pole obowiązkowe"]
        },
        personName: {
          field: "",
          rules: [v => !!v || "Pole obowiązkowe"]
        },
        phone: {
          field: "",
          rules: [
            v => !!v || "Pole obowiązkowe",
            v =>
              /^[0-9]*$/.test(v) ||
              "Telefon kontaktowy musi zawierać tylko cyfry. Nie może zawierać znaków specjalnych ani spacji."
          ]
        },
        mail: {
          field: "",
          rules: [
            v => !!v || "Pole obowiązkowe",
            v =>
              /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
              "Adres e-mail musi być poprawny"
          ]
        },
        purpose: {
          field: "",
          rules: [v => !!v || "Pole obowiązkowe"]
        },
        placeOfUse: {
          field: [
            { value: false, label: "ogłoszenie prasowe" },
            {
              value: false,
              label: "strona internetowa"
            },
            {
              value: false,
              label: "internetowy baner reklamowy"
            },
            {
              value: false,
              label: "broszura/książka"
            },
            {
              value: false,
              label: "folder/informator"
            },
            {
              value: false,
              label: "druki okolicznościowe"
            },
            {
              value: false,
              label: "drukowany baner reklamowy"
            },
            {
              value: false,
              label: "plakat/afisz"
            },
            {
              value: false,
              label: "tekstylia"
            },
            {
              value: false,
              label: "inne"
            }
          ],
          rules: [v => !!v || "Pole obowiązkowe"]
        },
        typeOfLogo: {
          field: [
            {
              value: false,
              label: "papier firmowy (dostępny tylko w formacie .docx)",
              tooltip: "papier_firmowy.jpg"
            },
            {
              value: false,
              label: "księga znaku",
              tooltip: "ksiega_znaku.jpg"
            },
            {
              value: false,
              label: "sygnet 70",
              tooltip: "sygnet.jpg"
            },
            {
              value: false,
              label: "logotyp bez przedziału lat",
              tooltip: "logotyp_bez_przedzialu_lat.jpg"
            },
            {
              value: false,
              label: "logotyp z latami 1950-2020",
              tooltip: "logotyp_z_latami_1950-2020.jpg"
            },
            {
              value: false,
              label: "logotyp skala szarości (bez przedziału lat)",
              tooltip: "logotyp_skala_szarosci_bez_lat.jpg"
            },
            {
              value: false,
              label: "logotyp skala szarości (z latami 1950-2020)",
              tooltip: "logotyp_skala_szarosci_z_latami.jpg"
            },
            {
              value: false,
              label: "logotyp z białym napisem (bez przedziału lat)",
              tooltip: "logotyp_z_bialym_napisem_bez_dat.png"
            },
            {
              value: false,
              label: "logotyp z białym napisem (z latami 1950-2020)",
              tooltip: "logotyp_z_bialym_napisem_z_datami.png"
            }
          ],
          rules: [v => !!v || "Pole obowiązkowe"]
        },
        format: {
          field: [
            { value: false, label: "docx" },
            { value: false, label: "png" },
            {
              value: false,
              label: "jpg (do internetu RGB)"
            },
            {
              value: false,
              label: "jpg (do druku CMYK)"
            },
            {
              value: false,
              label: "tif (do internetu RGB)"
            },
            {
              value: false,
              label: "tif (do internetu CMYK)"
            },
            {
              value: false,
              label: "pdf"
            },
            {
              value: false,
              label: "eps"
            }
          ],
          rules: [v => !!v || "Pole obowiązkowe"]
        }
      },
      preparedFormToSend: {
        companyName: "",
        personName: "",
        phone: "",
        mail: "",
        purpose: "",
        placeOfUse: "",
        typeOfLogo: "",
        format: ""
      },
      readyToSend: [],
      showSuccessAlert: false,
      showErrorAlert: false,
      showSendButton: true,
      placeOfUseValid: false,
      typeOfLogoValid: false,
      formatValid: false,
      showPlaceOfUseError: false,
      showTypeOfLogoError: false,
      showFormatError: false
    };
  },

  methods: {
    prepareFormData() {
      this.preparedFormToSend.companyName = this.logotypeForm.companyName.field;
      this.preparedFormToSend.personName = this.logotypeForm.personName.field;
      this.preparedFormToSend.phone = this.logotypeForm.phone.field;
      this.preparedFormToSend.mail = this.logotypeForm.mail.field;
      this.preparedFormToSend.purpose = this.logotypeForm.purpose.field;

      this.logotypeForm.placeOfUse.field.forEach(element => {
        let elementAlreadyIn = this.preparedFormToSend.placeOfUse.includes(
          element.label
        );
        if (element.value == true && !elementAlreadyIn) {
          this.preparedFormToSend.placeOfUse += element.label + ", ";
        }
      });

      this.logotypeForm.typeOfLogo.field.forEach(element => {
        let elementAlreadyIn = this.preparedFormToSend.typeOfLogo.includes(
          element.label
        );
        if (element.value == true && !elementAlreadyIn) {
          this.preparedFormToSend.typeOfLogo += element.label + ", ";
        }
      });

      this.logotypeForm.format.field.forEach(element => {
        let elementAlreadyIn = this.preparedFormToSend.format.includes(
          element.label
        );
        if (element.value == true && !elementAlreadyIn) {
          this.preparedFormToSend.format += element.label + ", ";
        }
      });

      return this.preparedFormToSend;
    },

    clearCheckBoxes() {
      this.logotypeForm.placeOfUse.field.forEach(element => {
        element.value = false;
      });
      this.logotypeForm.typeOfLogo.field.forEach(element => {
        element.value = false;
      });
      this.logotypeForm.format.field.forEach(element => {
        element.value = false;
      });
    },

    checkForm() {
      this.prepareFormData();
      this.checkPlaceOfUse();
      this.checkTypeOfLogo();
      this.checkFormat();

      if (
        this.checkPlaceOfUse() == "valid" &&
        this.checkTypeOfLogo() == "valid" &&
        this.checkFormat() == "valid"
      ) {
        this.validate();
      } else this.showErrorAlert = true;
    },

    checkPlaceOfUse() {
      this.preparedFormToSend.placeOfUse = "";
      this.prepareFormData();
      if (this.preparedFormToSend.placeOfUse == "") {
        this.placeOfUseValid = false;
        this.showPlaceOfUseError = true;
        return "invalid";
      } else {
        this.placeOfUseValid = true;
        this.showPlaceOfUseError = false;
        return "valid";
      }
    },

    checkTypeOfLogo() {
      this.preparedFormToSend.typeOfLogo = "";
      this.prepareFormData();
      if (this.preparedFormToSend.typeOfLogo == "") {
        this.typeOfLogoValid = false;
        this.showTypeOfLogoError = true;
        return "invalid";
      } else {
        this.typeOfLogoValid = true;
        this.showTypeOfLogoError = false;
        return "valid";
      }
    },

    checkFormat() {
      this.preparedFormToSend.format = "";
      this.prepareFormData();
      if (this.preparedFormToSend.format == "") {
        this.formatValid = false;
        this.showFormatError = true;
        return "invalid";
      } else {
        this.formatValid = true;
        this.showFormatError = false;
        return "valid";
      }
    },

    validate() {
      if (this.$refs.logotypeForm.validate()) {
        const formData = new FormData();
        formData.append("companyName", this.preparedFormToSend.companyName);
        formData.append("personName", this.preparedFormToSend.personName);
        formData.append("phone", this.preparedFormToSend.phone);
        formData.append("mail", this.preparedFormToSend.mail);
        formData.append("purpose", this.preparedFormToSend.purpose);
        formData.append("placeOfUse", this.preparedFormToSend.placeOfUse);
        formData.append("typeOfLogo", this.preparedFormToSend.typeOfLogo);
        formData.append("format", this.preparedFormToSend.format);

        this.$http
          .post(
            "https://app.umw.edu.pl/headless/form/send-form.php",
            formData
          )
          .then(response => console.log(response))
          .catch(error => console.log(error));

        console.log("Yay! Form send.");

        this.$refs.logotypeForm.reset();
        this.clearCheckBoxes();

        this.showErrorAlert = false;
        this.showSuccessAlert = true;
        this.showSendButton = false;
      } else {
        this.showErrorAlert = true;
        console.log("Invalid form");
      }
    }
  },

  created() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
